const binding = { modules: {}, dataActions: {} };

    (binding.modules['cus-sprii-integration'] = {
        c: () => require('partner/modules/cus-sprii-integration/cus-sprii-integration.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cus-sprii-integration',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cus-sprii-integration'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };